import React from "react";
import Typography from "style-guide/component/Typography";

type StatSection = {
  label: string;
  value?: number | string;
};

interface StatCardProps {
  label: string;
  value?: number | string;
  sections?: StatSection[];
}

export const StatCard: React.FC<StatCardProps> = ({
  label,
  value,
  sections = [],
}) => {
  return (
    <div className="p-4 rounded-xl bg-gray-100 flex flex-col justify-between gap-3">
      {/* Main Stat */}
      <div className="flex flex-col gap-2">
        <Typography variant="Base" text={label} className="text-[#00000099]" />
        {value && <Typography variant="Heading 3" text={value.toString()} />}
      </div>

      {/* Subsections */}
      {sections.length > 0 && (
        <div className="flex flex-col gap-2 border-t border-gray-200 pt-2">
          {sections.map((section, idx) => (
            <div
              key={idx}
              className="flex justify-between items-center text-sm"
            >
              <Typography
                variant="Base"
                text={section.label}
                className="text-gray-500"
              />
              <Typography
                variant="Base"
                text={`${section.value}`}
                className="!font-medium"
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
